import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { CheckCircleIcon, XMarkIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'

export default function Toast({type, message, onComplete}) {
  const [toasts, setToasts] = useState([])
  
  const toastTypes = {
    success: { icon: CheckCircleIcon, color: 'green' },
    error: { icon: ExclamationTriangleIcon, color: 'red' },
    warning: { icon: ExclamationTriangleIcon, color: 'yellow' },
    info: { icon: InformationCircleIcon, color: 'blue' }
  }

  const addToast = (type, message) => {
    const newToast = {
      id: Date.now(),
      type,
      message,
      visible: true
    }
    setToasts(prev => [newToast, ...prev])
  }
  useEffect(() => {
      if(type && message){
        addToast(type, message);
      } 
  }, [type, message])

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id))
    onComplete();
  }

  return (
    <>
      {type&&message&&
        <div className="fixed top-4 right-4 z-50 space-y-2">
          <AnimatePresence>
            {toasts.map((toast) => {
              const Icon = toastTypes[toast.type].icon
              const color = toastTypes[toast.type].color
              
              return (
                <motion.div
                  key={toast.id}
                  initial={{ x: 100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: 100, opacity: 0 }}
                  transition={{ type: 'spring', stiffness: 200, damping: 20 }}
                  className={`relative flex items-center w-80 p-4 rounded-lg shadow-lg bg-white border-l-4 border-${color}-500`}
                >
                  <Icon className={`w-6 h-6 mr-3 text-${color}-500`} />
                  
                  <div className="flex-1 text-sm font-medium text-gray-900">
                    {toast.message}
                  </div>
                  
                  <button
                    onClick={() => removeToast(toast.id)}
                    className="ml-2 p-1 rounded-full hover:bg-gray-100 transition-colors"
                  >
                    <XMarkIcon className="w-5 h-5 text-gray-500" />
                  </button>

                 
                  <motion.div
                    className={`absolute bottom-0 left-0 h-1 bg-${color}-500`}
                    initial={{ width: '100%' }}
                    animate={{ width: '0%' }}
                    transition={{ duration: 5, ease: 'linear' }}
                    onAnimationComplete={() => removeToast(toast.id)}
                  />
                </motion.div>
              )
            })}
          </AnimatePresence>
        </div>}
    </>
  )
}